import { useState } from "react";
import Modal from "react-modal";
import api from "../utils/axiosInstance";
import "../styles/PasswordModal.css";

Modal.setAppElement("#root");

const ChangePasswordModal = ({ isOpen, onClose, userId }) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            await api.put(`/users/${userId}/password`, { password }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setSuccessMessage("Password changed successfully");
            setPassword("");
            setConfirmPassword("");
        } catch (err) {
            setError("Password change error");
        }
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="password-modal-content" overlayClassName="password-modal-overlay">
            <div className="password-modal-header">
                <h2 className="password-modal-title">Change password</h2>
                <button className="password-modal-close" onClick={onClose}>×</button>
            </div>
            {error && <p className="text-red-500">{error}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}
            <form onSubmit={handleSubmit} className="password-modal-form">
                <input
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <button type="submit" className="password-modal-button">Change password</button>
            </form>
        </Modal>
    );
};

export default ChangePasswordModal;
